module.exports = __webpack_public_path__ + "media/src/images/icons/clocks/white-48c1777b1980aadb2675a80399b2908e.svg";